import React from 'react';
import styled from 'styled-components';
import { RiFileChartFill, RiMicrosoftFill } from 'react-icons/ri';

// Style the wrapper
const StyledIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type the icon properly
const TypedMicrosoftFill = RiMicrosoftFill as unknown as React.FC<{ size?: number | string }>;

const MicrosoftIcon: React.FC = () => (
  <StyledIconWrapper>
    <TypedMicrosoftFill size={24} />
  </StyledIconWrapper>
);

export default MicrosoftIcon;
